// extracted by mini-css-extract-plugin
export default {"ingredient__list":"burger-ingredient-category_ingredient__list__YHTan"};